import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { STAFF_DEFAULT_SCREEN } from '../constant/staff-default-screen.config';

@Component({
  selector: 'app-staff-pagenotfound',
  templateUrl: './staff-pagenotfound.component.html',
  styleUrls: ['../shared/staff-common.css', './staff-pagenotfound.component.css']
})
export class StaffPagenotfoundComponent {
  constructor(private router: Router) {}

  goToDefaultScreen() {
    this.router.navigate(['/staff', STAFF_DEFAULT_SCREEN]);
  }
}
